import { render } from "./UzhnetSwitch.vue?vue&type=template&id=7a18a82a&scoped=true"
import script from "./UzhnetSwitch.vue?vue&type=script&lang=js"
export * from "./UzhnetSwitch.vue?vue&type=script&lang=js"

import "./UzhnetSwitch.vue?vue&type=style&index=0&id=7a18a82a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a18a82a"]])

export default __exports__